import _ from 'lodash'
import { populateProgramGuide, populateProgramGuideCareers, populateProgramCareerResult,
  saveProgramGuide, saveEnrollmentStatus, getProgramGuides, deleteMultipleProgramGuides, doCsvUploadForMajorMinor,
  getPragyaMajorMinors, getMajorMinors, getMajorMinor, saveMajorMinor, getDemoWidgetMajorMinors,
  callFetchFileFromDriveAndUploadToS3, callBulkUploadProgramGuide, deleteMultipleMajorMinors,
  postRegisterProspectiveStudent, callBulkDeleteProgramGuide, callBulkDeleteMajorMinor,
  postFinishAccountSetup, doCsvUploadForTransferCredentialMapping, getProgramGuideByUuid,
  getLearnerExplorePrograms, getLearnerEnrolledProgram, getAlumniInsightForProgram,
  getTopAlumniCareersForProgram, getTopEmployersForAlumniCareer, getTopAlumniCompaniesForProgram,
  getTopAlumniIndustriesForProgram, getTopAlumniJobTitlesForProgram, bulkUploadAlumniInsight,
  deleteAllAlumniInsightCount, deleteAllAlumniInsight, putCreatePaymentIntent,
  putFinalizePaymentIntent, getInstitutionPaymentPublicCredentials, getProgramGuideByCodeAndInstitutionId,
  getCheckValidityOfCoupon, getCouponCode, getUserSISProgramMapping, putCreateApplication,getProgramReportToCsv,
  getResendApplicationLink, doProcessConvertProgram, doProcessConvertStructure, doProcessProgramGuideStructure, populateProgramGuideEnrollments, populateProgramTracking, getLearnerEnrolledProgramForCode, unarchiveProgramGuideForES, archiveProgramGuideForES, getPaymentLink, getAllUserSISProgramMappings, saveChangeProgramEnrollment, putCreateSubscription } from '../api'

export const loadProgramGuideByUuid = ({ state, commit }, uuid) => {
  return getProgramGuideByUuid(uuid)
}
export const exportProgramReportToCsv = ({ state, commit }, uuid) => {
  return getProgramReportToCsv(uuid)
}
export const loadProgramGuideByCodeAndInstitutionId = ({ state, commit }, {code, cipCode, type, institutionId}) => {
  return getProgramGuideByCodeAndInstitutionId(code, cipCode, type, institutionId)
}

export const loadProgramGuide = ({ state, commit }, {cipCode, programGuideCode, type, loadDataFromServer, programInstitutionId}) => {
  if (loadDataFromServer || _.isEmpty(state.programGuideObject)) {
    return populateProgramGuide(cipCode, programGuideCode, type, programInstitutionId).then((response) => {
      commit('LOAD_PROGRAM_GUIDE', response)
      return response
    })
  } else {
    commit('LOAD_PROGRAM_GUIDE', state.programGuideObject)
    return state.programGuideObject
  }
}
export const loadProgramTracking = ({ state, commit }, programGuideCode) => {
    return populateProgramTracking(programGuideCode).then((response) => {
      return response
    })
}

export const loadProgramGuides = ({ state, commit }, {page, count, title}) => {
  return getProgramGuides(page, count, title).then(response => {
    commit('LOAD_PROGRAM_GUIDES', response)
    return response
  })
}

export const loadProgramCareerResult = ({ state, commit }, {cipCode, programCode, locationParam}) => {
  return populateProgramCareerResult(cipCode, programCode, locationParam).then((response) => {
    commit('LOAD_PROGRAM_CAREER_RESULT', response)
    return response
  })
}

export const resetProgramCareerResult = ({ state, commit }) => {
  commit('LOAD_PROGRAM_CAREER_RESULT', {})
}

export const uploadProgramGuide = ({ state, commit }, {programGuideData}) => {
  return saveProgramGuide(programGuideData).then((response) => {
    return response
  })
}

export const loadProgramGuideCareers = ({ state, commit }, {cipCode, code, showAllOccupations, locationParam}) => {
  return populateProgramGuideCareers(cipCode, code, showAllOccupations, locationParam).then((response) => {
    commit('LOAD_PROGRAM_GUIDE_CAREERS', response)
    return response
  })
}
export const loadProgramGuideEnrollments = ({ state, commit }, {cipCode, code}) => {
  return populateProgramGuideEnrollments(cipCode, code).then((response) => {
    return response
  })
}

export const processProgramGuideStructure = ({ state, commit }, {cipCode, code, dryRun}) => {
  return doProcessProgramGuideStructure(cipCode, code, dryRun).then((response) => {
    return response
  })
}
export const processConvertStructure = ({ state, commit }, {userId, code, dryRun}) => {
  return doProcessConvertStructure(userId, code, dryRun).then((response) => {
    return response
  })
}
export const processConvertProgram = ({ state, commit }, { code, dryRun}) => {
  return doProcessConvertProgram( code, dryRun).then((response) => {
    return response
  })
}
export const updateShowAllOccupations = ({ state, commit }, showAllOccupations) => {
  commit('LOAD_SHOW_ALL_OCCUPATIONS', showAllOccupations)
}

export const deleteProgramGuides = ({ state, commit }, itemsToDelete) => {
  return deleteMultipleProgramGuides(itemsToDelete)
}

export const archiveProgramGuide = ({ state, commit }, programGuideId) => {
  return archiveProgramGuideForES(programGuideId)
}
export const unarchiveProgramGuide = ({ state, commit }, programGuideId) => {
  return unarchiveProgramGuideForES(programGuideId)
}

export const uploadMajorMinorCsvFile = ({ state, commit }, {fileData}) => {
  return doCsvUploadForMajorMinor(fileData).then(res => {
    return res
  })
}

export const loadMajorMinor = ({ state, commit }, {code}) => {
  return getMajorMinor(code).then(res => {
    return res
  })
}

export const loadMajorMinors = ({ state, commit }, {page, count, name, skipMinor}) => {
  return getMajorMinors(page, count, name, skipMinor).then(res => {
    return res
  })
}

export const loadDemoWidgetMajorMinors = ({ state, commit }, {token, page, count, name}) => {
  return getDemoWidgetMajorMinors(token, page, count, name)
}

export const loadPragyaMajorMinors = ({ state, commit }) => {
  return getPragyaMajorMinors().then(res => {
    return res
  })
}

export const storeMajorMinor = ({ state, commit }, majorMinorObject) => {
  return saveMajorMinor(majorMinorObject).then((response) => {
    return response
  })
}

export const loadFinishAccountSetup = ({ state, commit }, userObj) => {
  return postFinishAccountSetup(userObj).then(res => {
    let fullName = userObj.firstName + ' ' + userObj.lastName
    localStorage.setItem('userFullName', fullName)
    commit('LOAD_USER_NAME', fullName)
    return res
  })
}

export const loadFetchFileFromDriveAndUploadToS3 = ({ state, commit }, googleOAuthToken) => {
  return callFetchFileFromDriveAndUploadToS3(googleOAuthToken)
}

export const bulkUploadProgramGuide = ({ state, commit }, { fileData }) => {
  return callBulkUploadProgramGuide(fileData)
}

export const loadRegisterProspectiveStudent = ({ state, commit }, {learningSpaceId, prospectiveStudentForm}) => {
  return postRegisterProspectiveStudent(learningSpaceId, prospectiveStudentForm).then((response) => {
    return response
  })
}

export const bulkDeleteProgramGuide = ({ state, commit }) => {
  return callBulkDeleteProgramGuide()
}

export const deleteMajorMinors = ({ state, commit }, itemsToDelete) => {
  return deleteMultipleMajorMinors(itemsToDelete)
}

export const bulkDeleteMajorMinor = ({ state, commit }) => {
  return callBulkDeleteMajorMinor()
}

export const loadLearnerExplorePrograms = ({ state, commit }) => {
  return getLearnerExplorePrograms()
}

export const loadLearnerEnrolledProgram = ({ state, commit }, userId) => {
  return getLearnerEnrolledProgram(userId).then((response) => {
    if (!userId)
      commit('LOAD_PROGRAM_GUIDE', response)
    return response
  })
}

export const loadLearnerEnrolledProgramForCode = ({ state, commit }, programCode) => {
  return getLearnerEnrolledProgramForCode(programCode).then((response) => {
      commit('LOAD_PROGRAM_GUIDE', response)
    return response
  })
}
export const loadSaveEnrollmentStatus = ({ state, commit }, {programCode, status}) => {
  return saveEnrollmentStatus(programCode, status)
}
export const changeProgramEnrollment = ({ state, commit }, {userId, currentProgramCode, requestedProgramCode}) => {
  return saveChangeProgramEnrollment(userId,currentProgramCode, requestedProgramCode)
}

export const loadProgramAlumniData = ({ state, commit }, programCode) => {
  return getAlumniInsightForProgram(programCode).then(response => {
    commit('LOAD_PROGRAM_ALUMNI_DATA', response)
    return response
  })
}

export const loadTopAlumniCareers = ({ state, commit }, programCode) => {
  return getTopAlumniCareersForProgram(programCode)
}

export const loadTopEmployersForAlumniCareer = ({ state, commit }, {programCode, careerSoc}) => {
  return getTopEmployersForAlumniCareer(programCode, careerSoc)
}

export const loadTopAlumniCompanies = ({ state, commit }, programCode) => {
  return getTopAlumniCompaniesForProgram(programCode)
}

export const loadTopAlumniIndustries = ({ state, commit }, programCode) => {
  return getTopAlumniIndustriesForProgram(programCode)
}

export const loadTopAlumniJobTitles = ({ state, commit }, programCode) => {
  return getTopAlumniJobTitlesForProgram(programCode)
}

export const loadBulkUploadAlumniInsight = ({ state, commit }, { fileData }) => {
  return bulkUploadAlumniInsight(fileData)
}

export const loadDeleteAllAlumniInsightCount = ({ state, commit }) => {
  return deleteAllAlumniInsightCount()
}

export const loadDeleteAllAlumniInsight = ({ state, commit }) => {
  return deleteAllAlumniInsight()
}

export const loadPutCreatePaymentIntent = ({ state, commit }, transactionObj) => {
  return putCreatePaymentIntent(transactionObj)
}

export const loadPutFinalizePaymentIntent = ({ state, commit }, transactionId) => {
  return putFinalizePaymentIntent(transactionId)
}

export const loadGetInstitutionPaymentPublicCredentials = ({ state, commit }, institutionId) => {
  return getInstitutionPaymentPublicCredentials(institutionId)
}

export const loadGetCheckValidityOfCoupon = ({ state, commit }, {couponCode, programCode, pricingPlanId}) => {
  return getCheckValidityOfCoupon(couponCode, programCode, pricingPlanId)
}

export const loadGetCouponCode = ({ state, commit }, couponCode) => {
  return getCouponCode(couponCode)
}

export const loadUserSISProgramMapping = ({ state, commit }, {sisProgramId, sisDegreeId}) => {
  return getUserSISProgramMapping(sisProgramId, sisDegreeId)
}

export const loadCreateApplication = ({ state, commit }, {sisProgramId, sisDegreeId}) => {
  return putCreateApplication(sisProgramId, sisDegreeId)
}

export const loadResendApplicationLink = ({ state, commit }, {sisProgramId, sisDegreeId}) => {
  return getResendApplicationLink(sisProgramId, sisDegreeId)
}

export const loadPaymentLink = ({ state, commit }, {sisProgramId, sisDegreeId}) => {
  return getPaymentLink(sisProgramId, sisDegreeId)
}

export const loadAllUserSISProgramMappings = ({ state, commit }) => {
  return getAllUserSISProgramMappings()
}

export const loadCreateSubscription = ({ state, commit }, transactionObj) => {
  console.log("create subscription got called")
  return putCreateSubscription(transactionObj)
}



// WEBPACK FOOTER //
// ./src/app/programguide/vuex/actions.js